import { Button, Grid, Skeleton, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";
import Slider from "react-slick";
import Color from "../../../assets/colors";

export const GridStyled = styling(Grid)((props) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  margin: "auto",
  top: "68px",
  // height: "680px",
  // maxWidth: "1440px",
  // position: "sticky",
  // paddingBottom: "100px",

  [props.theme.breakpoints.down("lg")]: {
    // height: "630px",
    paddingBottom: "0px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    // height: "630px",
    paddingBottom: "0px",
  },
}));

export const SliderStyled = styling(Slider)((props) => ({
  //   height: props.logoCarousel ? "auto" : "550px !important",
  width: "100%",
}));

export const SliderWrapper = styling(Grid)((props) => ({
  // overflow: "hidden",
  display: "flex",
  alignItems: "flex-end",
  position: "relative",
  width: "100%",
  // height: "75vh",
  // top: "68px",
  // position: "sticky",
  // top: "68px",
  transition: "height 0.3s linear",
  zIndex: 10,

  [props.theme.breakpoints.down("tablet")]: {
    height: "75vh",
  },

  "@media (max-width:  378px)": {
    height: "85vh",
  },
}));

export const ImageGrid = styling(Grid)((props) => ({
  padding: "10px",
  backgroundImage: `url(${props.image})`,
  display: "flex !important",
  alignItems: "center",
  width: "100%",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "cover",
  transition: "all 0.3s",

  [props.theme.breakpoints.down("lg")]: {
    height: "83vh",
    // backgroundPosition: "unset",
  },

  [props.theme.breakpoints.down("tablet")]: {
    height: "76vh",
    backgroundPosition: "center",
  },

  "@media (max-width: 1280px) and (min-width: 1000px)": {
    height: "1300px",
    backgroundPosition: "center",
  },

  "@media (max-width: 1000px) and (min-width: 900px)": {
    height: "96vh",
  },

  "@media (max-width: 900px) and (min-width: 820px)": {
    height: "92vh",
  },

  "@media (max-width: 820px) and (min-width: 768px)": {
    height: "95vh",
  },

  "@media (max-width: 378px)": {
    height: "85vh",
  },
}));

// For the white container within the slider
export const SliderInnerContainer = styling(Grid)((props) => ({
  width: "576px",
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  position: "absolute",
  zIndex: 100,
  justifyContent: "space-between",
  bottom: "18%",

  [props.theme.breakpoints.up("xl")]: {
    right: "25%",
  },

  [props.theme.breakpoints.down("xl")]: {
    right: "13%",
  },

  [props.theme.breakpoints.down("lg")]: {
    width: "100%",
    marginBottom: props.bannerCount <= 1 ? "10px" : "40px",
    padding: "16px 18px 54px 18px",
    justifyContent: "space-between",
    right: "unset",
    // bottom: "-21%",
    bottom: "-10%",
    left: "50%", // Center horizontally
    transform: "translate(-50%, -50%)", // Adjust position from center
    gap: "32px",
    maxWidth: "596px",
    justifyContent: "center",
    alignItems: "center",
  },

  "@media (max-width: 1000px) and (min-width: 900px)": {
    // bottom: "-19%",
    bottom: "-10%",
  },

  "@media (max-width: 900px) and (min-width: 834px)": {
    // bottom: "-24%",
    bottom: "-10%",
  },

  "@media only screen and (min-device-width: 820px) and (max-device-width: 834px) and (-webkit-min-device-pixel-ratio: 2)":
    {
      bottom: "-10%",
    },

  "@media (max-width: 820px)": {
    // bottom: "-18%",
    bottom: "-15%",
  },

  [props.theme.breakpoints.down("sm")]: {
    bottom: "-0%",
    gap: "24px",
    left: "unset", // Center horizontally
    transform: "unset", // Adjust position from center
  },

  "@media (max-width: 400px)": {
    bottom: "-6%",
  },
}));

export const TextContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  alignItems: "flex-start",

  [props.theme.breakpoints.down("lg")]: {
    gap: "8px",
    alignItems: "center",
    textAlign: "center",
  },
}));

export const SliderBoldTitle = styling("h1")((props) => ({
  color: `rgba(255, 255, 255, 0.87)`,
  fontFamily: "Georgia",
  fontSize: "60px",
  fontWeight: "400",
  lineHeight: "70px",
  margin: "0px",
  letterSpacing: "0.6px",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "36px",
    lineHeight: "43.2px",
    maxWidth: "unset",
    letterSpacing: "0.36px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "32px",
    lineHeight: "38.4px",
    maxWidth: "312px",
    letterSpacing: "0.32px",
  },
}));

export const SliderDescription = styling(Typography)((props) => ({
  color: `rgba(255, 255, 255, 0.87)`,
  fontSize: "20px",
  fontWeight: "500",
  lineHeight: "26px",
  letterSpacing: "unset",
  fontFamily: "Inter",

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "22.4px",
  },
}));

export const ButtonContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  gap: "10px",

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

export const SignUpButton = styling(Button)((props) => ({
  borderRadius: "100px",
  fontSize: "16px",
  fontWeight: "700",
  height: "56px",
  width: "160px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textTransform: "capitalize",
  border: `2px solid ${Color.black}`,
  color: Color.black,
  backgroundColor: "white",
  textTransform: "none",

  ":hover": {
    backgroundColor: Color.white,
    border: `2px solid ${Color.black}`,
  },
}));

export const ContactUsButton = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: " 1px solid rgba(255, 200, 60, 0.40)",
  background: "linear-gradient(180deg, #FD5 50%, #FFB800 122.92%)",
  boxShadow:
    "0 -1px 4px 0 rgba(255, 255, 255, 0.00) inset, 0 4px 16px 0 rgba(0, 0, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    backgroundColor: "#FFDE24",
  },

  [props.theme.breakpoints.down("lg")]: {
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

// Company Logos
export const OuterLogoContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "14px",
  width: "100%",
  height: "auto",
}));

export const LogoContainer = styling(Grid)((props) => ({
  overflow: "scroll",
  flexWrap: "nowrap",
}));

export const LogoTitle = styling(Typography)((props) => ({
  textAlign: "center",
  color: "black",
  fontSize: "25px",
  fontWeight: 700,
  lineHeight: "32px",
}));

export const LogoTitlePurple = styling("span")((props) => ({
  color: "#512ACC",
  fontSize: "25px",
  fontWeight: 700,
  lineHeight: "32px",
}));

// new content box
export const SliderInnerContent = styling(Grid)((props) => ({
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "row",
  position: "absolute",
  zIndex: 100,
  justifyContent: "center",
  alignItems: "center",
  padding: "100px 80px",
  gap: "86px",
  flexShrink: 0,

  [props.theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    gap: "48px",
    padding: "88px 24px 48px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "24px",
    padding: "64px 24px 24px 24px",
  },
}));

export const ImageStyled = styling("img")((props) => ({
  // width: "100%",
  height: "auto",
  aspectRatio: "1 / 1",
  objectFit: "cover",
  maxWidth: "400px", // 440px
  borderRadius: "20px",
  border: "0.86px solid #AEAEAE",
  boxShadow: "14.545px 14.545px 15.182px 0px #1F063F",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "456px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "280px",
  },
}));

export const RightContent = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  maxWidth: "594px",
  alignItems: "flex-start",
  gap: "48px",
  flexShrink: 0,

  [props.theme.breakpoints.down("lg")]: {
    alignItems: "center",
    gap: "48px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "24px",
  },
}));

export const SkeletonContainer = styling("div")((props) => ({
  display: "flex",
  justifyContent: "center",

  ...(props.type == "main-container" && {
    gap: "86px",
    alignSelf: "stretch",
    textAlign: "center",
    padding: "80px 160px 80px 200px",
    minHeight: "500px",
    background:
      "linear-gradient(181deg, #10062B 42.3%, rgba(65, 48, 117, 0.80) 164.78%)",
    height: "100%",
  }),

  ...(props.type == "sub-container" && {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "32px",
    width: "594px",
  }),

  ...(props.type == "text-container" && {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
    width: "480px",
  }),

  ...(props.type == "subtext-container" && {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px",
    width: "480px",
  }),

  [props.theme.breakpoints.down("lg")]: {
    ...(props.type == "main-container" && {
      gap: "48px",
      alignSelf: "stretch",
      textAlign: "center",
      padding: "48px 24px",
      minHeight: "1020px",
      alignItems: "center",
      flexDirection: "column",
    }),

    ...(props.type == "sub-container" && {
      alignItems: "center",
      gap: "32px",
      width: "594px",
    }),

    ...(props.type == "text-container" && {
      flexDirection: "column",
      alignItems: "center",
    }),
  },

  [props.theme.breakpoints.down("tablet")]: {
    ...(props.type == "main-container" && {
      gap: "24px",
      alignSelf: "stretch",
      textAlign: "center",
      padding: "24px",
      minHeight: "542px",
      alignItems: "center",
      flexDirection: "column",
    }),

    ...(props.type == "sub-container" && {
      alignItems: "center",
      gap: "24px",
      width: "312px",
    }),

    ...(props.type == "text-container" && {
      width: "312px",
    }),

    ...(props.type == "subtext-container" && {
      gap: "4px",
      width: "312px",
    }),
  },
}));

export const SkeletonStyled = styling(Skeleton)((props) => ({
  background: "rgba(255, 255, 255, 0.40)",
  backgroundColor: "rgba(255, 255, 255, 0.40)",
  transform: "scale(1)",

  ...(props.type == "image" && {
    width: "400px",
    height: "400px",
    borderRadius: "16px",
  }),

  ...(props.type == "button" && {
    width: "180px",
    height: "48px",
    borderRadius: "30px",
  }),

  ...(props.type == "small-title" && {
    width: "480px",
    height: "24px",
    borderRadius: "20px",
  }),

  ...(props.type == "title" && {
    width: "480px",
    height: "60px",
    borderRadius: "30px",
  }),

  [props.theme.breakpoints.down("lg")]: {
    ...(props.type == "image" && {
      width: "556px",
      height: "556px",
      borderRadius: "22.24px",
    }),

    ...(props.type == "button" && {
      borderRadius: "24px",
    }),

    ...(props.type == "small-title" && {
      borderRadius: "16px",
    }),
  },

  [props.theme.breakpoints.down("tablet")]: {
    ...(props.type == "image" && {
      width: "280px",
      height: "280px",
      borderRadius: "11.2px",
    }),

    ...(props.type == "button" && {
      width: "280px",
      height: "48px",
      borderRadius: "24px",
    }),

    ...(props.type == "small-title" && {
      width: "312px",
      height: "24px",
      borderRadius: "16px",
    }),

    ...(props.type == "title" && {
      width: "312px",
      height: "32px",
      borderRadius: "16px",
    }),
  },
}));

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 160px 80px 200px",
  flexDirection: "column",
  alignItems: "center",
  gap: "86px",
  marginTop: "40px",
  flexDirection: "row",
  justifyContent: "center",
  background:
    "linear-gradient(181deg, #10062B 42.3%, rgba(65, 48, 117, 0.80) 164.78%), #FFF;",

  [props.theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    padding: "48px 24px",
    gap: "48px",
    background:
      "linear-gradient(181deg, rgba(65, 48, 117, 0.80) -9.45%, #10062B 89.8%), #FFF;",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "24px",
    gap: "24px",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1200px",
  justifyContent: "space-between",
  alignItems: "center",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "720px",
    flexDirection: "column-reverse",
    alignItems: "center",
    gap: "24px",
    alignSelf: "stretch",
    margin: "auto",
    textAlign: "center",
  },

  [props.theme.breakpoints.down("tablet")]: {
    textAlign: "left",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "100%",
  width: "100%",
  flexShrink: "0",
  borderRadius: "8px",
  maxHeight: "100%",
  maxWidth: "500px",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "500px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "330px",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "24px",
  maxWidth: "600px",
  overflow: "visible",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "750px",
    alignItems: "center",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));
